function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.92086 6.71338C10.168 6.30001 10.6718 6.10966 11.1343 6.26381C11.5976 6.41825 11.8867 6.8743 11.835 7.35424L11.8331 7.36726V16.6324L11.835 16.6457C11.8845 17.1048 11.6221 17.542 11.1937 17.7143L11.1343 17.7362C10.6718 17.8903 10.168 17.7 9.92086 17.2866L9.916 17.2778L7.75491 14.4996L6.66667 14.5C6.04455 14.5 5.53617 14.0131 5.50185 13.3995L5.5 13.3333V10.6667C5.5 10.0445 5.98693 9.53616 6.60046 9.50184L6.66667 9.49999H7.75491L9.916 6.72181L9.92086 6.71338Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9796 10.2767L15.0202 10.3131L16 11.2931L16.9798 10.3131C17.1751 10.1178 17.4916 10.1178 17.6869 10.3131C17.8692 10.4953 17.8813 10.7833 17.7234 10.9796L17.6869 11.0202L16.7069 12L17.6869 12.9798C17.8822 13.175 17.8822 13.4916 17.6869 13.6869C17.5047 13.8691 17.2167 13.8813 17.0204 13.7233L16.9798 13.6869L16 12.7069L15.0202 13.6869C14.825 13.8821 14.5084 13.8821 14.3131 13.6869C14.1309 13.5046 14.1187 13.2167 14.2767 13.0204L14.3131 12.9798L15.2931 12L14.3131 11.0202C14.1179 10.8249 14.1179 10.5084 14.3131 10.3131C14.4832 10.143 14.7454 10.1211 14.9392 10.2473L14.9796 10.2767Z",
  fill: "white"
});

var SvgIconVolumnOff = function SvgIconVolumnOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconVolumnOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_volumn_off.24882697.svg";
export { ForwardRef as ReactComponent };